<ng-container *ngIf="document else loading">
	<div class="card-block">
		<div class="card-header">
			<div class="card-header-left">
				<mat-icon svgIcon="icon_order_acknowledgement" class="header-margin-right"></mat-icon>
				<span class="header-margin-right overflow-wrap">{{document.typeDescription ? document.typeDescription :
					UNDERSCORE}}</span>
			</div>
			<div class="card-container-link">
				<a mat-icon-button [href]="getDocumentURL(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'quapp.action.view' | translate">
					<mat-icon svgIcon="md:eye"></mat-icon>
				</a>
				<a mat-icon-button [href]="downloadDocument(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'sb.Download' | translate">
					<mat-icon svgIcon="md:download"></mat-icon>
				</a>
			</div>
		</div>
		<div class="card-content">
			<div class="content-grid-mobile">
				<div class="text-overflow-ellipsis">
					<div class="card-content-label" translate>commercial-documents.order-acknowledgement-number</div>
					<a class="card-header-value"
						[routerLink]="['/commercial-documents/cards/order-acknowledgment-card', document.id]">
						{{ document.name ? document.name : UNDERSCORE}}
					</a>
				</div>
				<div>
					<div class="card-content-label" translate>commercial-documents.order-acknowledgement-type</div>
					<div>{{ document.subtypeDescription ? document.subtypeDescription : UNDERSCORE }}</div>
				</div>
				<div class="card-header-right">
					<mat-icon svgIcon="calendar" class="header-margin-right grey-icon"></mat-icon>
					<div class="card-container-column">
						<span class="card-content-label" translate>datacenter-filter.creation-date</span>
						<span>{{ (document.date ? document.date : UNDERSCORE) | copoDate:'date' }}</span>
					</div>
				</div>
				<div>
					<div class="card-container-column">
						<span class="card-content-label" translate>commercial-documents.mill</span>
					</div>
					<div *ngFor="let docLine of document.documentLines; let i = index">
						<div class="card-container-column" *ngIf="i < 3">
							<span>
								{{ docLine.millDescription ? docLine.millDescription : UNDERSCORE }}
							</span>
						</div>
					</div>
				</div>
				<div>
					<div class="card-content-label" translate>commercial-documents.shipto</div>
					<div>{{ document.shiptoName ? document.shiptoName : UNDERSCORE }}</div>
				</div>
				<div>
					<div class="card-content-label" translate>commercial-documents.soldto</div>
					<div>{{ document.soldtoName ? document.soldtoName : UNDERSCORE}}</div>
				</div>
			</div>
		</div>
		<div class="card-container-column card-column-end">
			<div class="card-container-link">
				<a mat-button color="primary" (click)="redirectToOrderDatacenter(document)" [routerLink]="document.docNavigationLink">
					<span translate>commercial-documents.display-all-orders</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
			</div>
		</div>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
